import { ButtonGroup, FormGroup, Input, RadioGroup, SelectTree, Select as TSelect } from '@tencent/spaui';
import _ from 'lodash';
import Select from '../common/Select';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { getKeys } from '../pages/setting/clue/helper';
import {
  LogicRelation,
  MatchRelationType,
  ContainRelationType,
  RelationShipType,
  RuleApplyRangeType,
  getStandardFieldMap,
  FieldScope,
  FuzzyMatchFieldNames,
} from '../helper/RuleApplyRangeHelper';
import { useCheckWhiteList } from './../../utils/checkWhiteList';
import { RPCFactory } from './../../utils/RequestUtil';
import { judgeIsFxd } from '../../utils';
import { withXundaData } from '../../cacheAPIData/WithXundaData';

const CustomCampaignSelector = ({ onChange, value, placeholder, disabled }) => {
  const [list, setList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const displayList = useMemo(() => {
    return searchText ? searchList : list;
  }, [searchText, list, searchList]);

  const getList = useCallback((page = 1, txt = '', reset = false) => {
    RPCFactory.campaign.list({
      pageSize: 30,
      pageIndex: reset ? 1 : page,
      campaignName: txt,
    }).done((data) => {
      setLoading(false);
      if (!_.isArray(data.entities)) {
        throw new Error('响应数据格式不正确');
      }
      const list = data.entities.map((item) => ({
        value: item.campaignId,
        label: item.campaignName,
      }));
      const uniqArr = (arr) => _.uniqBy(arr.concat(list), 'value');
      setLabelList(uniqArr);
      if (txt) {
        setSearchList(uniqArr);
      } else {
        setList(uniqArr);
      }
    }).fail((ret, err) => {
      setLoading(false);
      alert(err);
    });
  }, []);

  useEffect(() => getList(1), [getList]);

  const handleSearch = (e, txt) => {
    setSearchText(txt);
    setSearchList([]);
    if (txt.length < 1) return;
    setLoading(true);
    getList(1, txt);
  };

  const handleOpen = () => {
    setSearchText('');
    setSearchList([]);
  };

  const scrollFetching = _.throttle(
    () => {
      let arr = list;
      if (searchText) arr = searchList;
      if (searchText && searchList.length < 1) return;
      getList(Math.floor(arr.length / 30) + 1, searchText);
    },
    1000,
    { leading: true, trailing: false },
  );

  const handleScroll = (e, [, bottom], height) => {
    if (height - bottom > 80) return;
    scrollFetching();
  };

  return (
    <TSelect
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      search
      multiple
      clearable
      style={{ maxWidth: 451 }}
      data={displayList}
      labelData={labelList}
      loading={loading}
      searchValue={searchText}
      onSearch={handleSearch}
      onOpen={handleOpen}
      onScroll={handleScroll}
    />
  );
};

const Page = (props) => {
  const {
    model,
    applyRangeType,
    setApplyRangeType,
    logicRelation,
    setLogicRelation,
    applyRangeDetailHooks,
    disabledAllField = false,
    source,
  } = props;
  const isShowXjLeadsSubSource = !!window.pageProps && useCheckWhiteList(window.pageProps.uid, 'xuanjing_config');
  const dynamicFieldMap = getStandardFieldMap({ isShowXjLeadsSubSource, source });
  const fieldMap = Object.keys(dynamicFieldMap).map((key) => ({
    value: dynamicFieldMap[key].value,
    label: dynamicFieldMap[key].label,
  }));
  const [selectData, setSelectData] = useState(fieldMap);

  // 房讯达的楼盘列表
  const xundaPools = props.xundaData.pools.map((item) => ({
    label: item.name,
    value: item.leads_pool_id,
  }));

  useEffect(() => {
    setSelectData(fieldMap);
  }, [isShowXjLeadsSubSource]);

  useEffect(() => {
    if (model === 'add') {
      applyRangeDetailHooks.onAdd();
    }
  }, []);

  // 重置标准字段名下拉框，保证每个条件使用的字段名不重复
  useEffect(() => {
    const map = getKeys(applyRangeDetailHooks.dataList, 'fieldName');

    const data = Object.keys(dynamicFieldMap).map((key) => ({
      value: dynamicFieldMap[key].value,
      label: dynamicFieldMap[key].label,
      disabled: !!map[key],
    }));

    setSelectData(data);
  }, [applyRangeDetailHooks.dataList]);

  const renderValue = (ele, index) => {
    const fieldDef = dynamicFieldMap[ele.fieldName];
    if (fieldDef && ele.fieldScope == 'STANDARD') {
      if (fieldDef.type === 'Select') {
        // 推广计划是从后台异步拉取的，特殊处理
        if (fieldDef.label === '推广计划') {
          return (
            <CustomCampaignSelector
              disabled={disabledAllField}
              placeholder={fieldDef.placeholder}
              value={ele.fieldValues}
              onChange={(e, value) => {
                applyRangeDetailHooks.onItemChangeBatch(index, {
                  fieldValues: value,
                  error: null,
                });
              }}
            />
          );
        }
        const selectProps = {
          data: fieldDef.data,
          value: ele.fieldValues,
        };
        if (fieldDef.value === 'leadsPoolId' && judgeIsFxd()) {
          selectProps.data = xundaPools;
        }
        return (
          <Select
            disabled={disabledAllField}
            valid={true}
            multiple
            clearable
            // data={fieldDef.data}
            placeholder={fieldDef.placeholder}
            value={ele.fieldName === 'leadsPoolId' ? ele.fieldValueDescs : ele.fieldValues}
            onChange={(e, value) => {
              applyRangeDetailHooks.onItemChangeBatch(index, {
                fieldValues: value,
                error: null,
              });
            }}
            {...selectProps}
          />
        );
      }
      if (fieldDef.type === 'SelectTree') {
        return (
          <div>
            <SelectTree
              multiple
              clearable={!disabledAllField}
              placeholder={fieldDef.placeholder}
              disabled={disabledAllField}
              showParentNodeLabel={false}
              value={ele.fieldValues}
              data={fieldDef.data}
              onChange={(e, value) => {
                applyRangeDetailHooks.onItemChangeBatch(index, {
                  fieldValues: value,
                  error: null,
                });
              }}
            />
          </div>
        );
      }
      return (
        <Input
          disabled={disabledAllField}
          placeholder={fieldDef.placeholder}
          value={_.isArray(ele.fieldValues) ? ele.fieldValues.join(',') : ele.fieldValues}
          onChange={(e, value) => {
            let fieldValues;
            if (value === '') {
              fieldValues = [];
            } else {
              fieldValues = value.split(/[,，]/);
            }
            applyRangeDetailHooks.onItemChangeBatch(index, {
              fieldValues,
              error: null,
            });
          }}
        />
      );
    }
    return (
      <Input
        disabled={disabledAllField}
        value={_.isArray(ele.fieldValues) ? ele.fieldValues.join(',') : ele.fieldValues}
        onChange={(e, value) => {
          applyRangeDetailHooks.onItemChangeBatch(index, {
            fieldValues: value.split(/[,，]/),
            error: null,
          });
        }}
        status={ele.error && ele.fieldValues.length === 0 ? 'error' : ''}
      />
    );
  };
  // 是否展示包含或不包含 add by fighiting
  const isShowContain = (ele) => {
    // 只有标准字段才判断matchStrategy
    if(ele.fieldScope === 'STANDARD'){
      if (ele.matchStrategy) {
        return ele.matchStrategy === RelationShipType.FUZZY_MATCH
      }
      // 标准字段默认都是包含
      return _.includes(FuzzyMatchFieldNames, ele.fieldName);
    }
    return false;
  }
  return (
    <div className="interface-setting" style={{ width: '-webkit-fill-available' }}>
      <ButtonGroup
        data={Object.keys(RuleApplyRangeType).map((key) => ({
          value: key,
          label: RuleApplyRangeType[key],
        }))}
        disabled={disabledAllField}
        value={applyRangeType}
        onChange={(event, value, buttonProps) => {
          setApplyRangeType(value);
          console.log(value);
        }}
      />
      {applyRangeType === 'CUSTOMIZE' && (
        <div className="info-des-sec">
          <div className="config-li">
            <div className="con-setting">
              <span className="tt">条件关系</span>
              <RadioGroup
                disabled={disabledAllField}
                data={Object.keys(LogicRelation).map((key) => ({
                  value: key,
                  children: LogicRelation[key],
                }))}
                value={logicRelation}
                onChange={(e, _value) => {
                  setLogicRelation(_value);
                }}
              />
            </div>
            {applyRangeDetailHooks.dataList.map((ele, index) => (
              <div className="form-in">
                <Select
                  valid={!(ele.error && ele.fieldScope === '')}
                  data={Object.keys(FieldScope).map((key) => ({
                    value: key,
                    label: FieldScope[key],
                  }))}
                  disabled={disabledAllField}
                  value={ele.fieldScope}
                  onChange={(e, _value) => {
                    applyRangeDetailHooks.onItemChangeBatch(index, {
                      fieldScope: _value,
                      fieldName: '',
                      fieldValues: [],
                    });
                  }}
                />
                {ele.fieldScope === 'STANDARD' && (
                  <Select
                    className="filter-key"
                    valid={!(ele.error && ele.fieldName === '')}
                    data={selectData}
                    disabled={disabledAllField}
                    value={ele.fieldName}
                    onChange={(e, _value) => {
                      applyRangeDetailHooks.onItemChangeBatch(index, {
                        fieldName: _value,
                        fieldValues: [],
                      });
                    }}
                  />
                )}
                {ele.fieldScope !== 'STANDARD' && (
                  <div style={{ width: '114px' }}>
                    <Input
                      value={!(ele.error && ele.fieldName === '') ? ele.fieldName : ''}
                      disabled={disabledAllField}
                      onChange={(e, value) => {
                        applyRangeDetailHooks.onItemChangeBatch(index, {
                          fieldName: value,
                          error: null,
                        });
                      }}
                      status={ele.error && ele.fieldName.length === 0 ? 'error' : ''}
                    />
                  </div>
                )}
                <Select
                  valid={!(ele.error && ele.matchRelation === '')}
                  data={Object.keys(isShowContain(ele) ? ContainRelationType : MatchRelationType).map((key) => ({
                    value: key,
                    label: isShowContain(ele) ? ContainRelationType[key] : MatchRelationType[key],
                  }))}
                  value={ele.matchRelation}
                  disabled={disabledAllField}
                  onChange={(e, _value) => {
                    applyRangeDetailHooks.onItemChangeBatch(index, {
                      matchRelation: _value,
                    });
                  }}
                />
                <FormGroup
                  status={ele.error && ele.fieldValues.length === 0 ? 'error' : ''}
                  style={{ width: 0 }}
                >
                  {renderValue(ele, index)}
                </FormGroup>
                {disabledAllField || index == 0 ? null : (
                  <div className="close-wraper">
                    <i
                      className="icon icon-close"
                      onClick={(e) => {
                        applyRangeDetailHooks.onDeleteItem(index);
                      }}
                    ></i>
                  </div>
                )}
              </div>
            ))}
            {!disabledAllField && (
              <a
                className="edit"
                onClick={() => {
                  applyRangeDetailHooks.onAdd();
                }}
              >
                ＋添加条件
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default withXundaData(Page);
